import type { SchoolLogsDtoTypeEnum } from '@/global/api/gen/ts/SchoolLogsDto';

export const LogTypesMapping: Record<SchoolLogsDtoTypeEnum, string> = {
    1: "Изменение кешбека"
};